<template>
  <shop-layout
    :show-download="isScroll"
    show-footer="true">
    <div
      :style="{height:ratio*522+'px'}"
      class="banner">
      <div
        v-if="showDownloadBtn"
        :style="{height:ratio*54+'px',
                 width:ratio*170+'px',top:ratio*328+'px',left:ratio*77+'px',
                 fontSize:ratio*18+'px',borderRadius:ratio*6+'px',lineHeight:ratio*54+'px'}"
        class="button"
        @click="download()">立即下载</div>
    </div>
    <div
      id="content-1"
      :style="{height:ratio*1102+'px'}"></div>
    <div
      id="content-2"
      :style="{height:ratio*470+'px'}"></div>
    <div
      id="content-3"
      :style="{height:ratio*660+'px'}">
      <a
        :style="{fontSize:ratio*18+'px',
                 top:594*ratio+'px'}"
        href="/cloudProduct"
        class="more-detail">更多详情 &nbsp;<i
          :style="{
            width:9*ratio+'px',
            height:14*ratio+'px'}"
      ></i></a>
    </div>
    <div
      id="content-4"
      :style="{height:ratio*792+'px'}"></div>
  </shop-layout>
</template>
<script>
/* eslint-disable import/no-unresolved */
import { Ajax, getBrowserVersion } from '@/lib/utils';
import { downloadClick } from './layout-common/pageRecord';
import ShopLayout from './layout-common/shop-layout';

export default {
  components: {
    ShopLayout,
  },
  data() {
    return {
      downloadUrl: '',
      version: '',
      showDownloadBtn: true,
      ratio: document.body.clientWidth / 1280,
      isScroll: false,
    };
  },
  created() {
    Ajax.get({
      url: 'pc/ajax/getDownloadUrl',
      success: (res) => {
        if (res.code !== '200') return;
        this.downloadUrl = res.data.url;
        this.version = res.data.version;
      },
    });
  },
  mounted() {
    const browser = {
      versions: getBrowserVersion(),
      // language: (navigator.browserLanguage || navigator.language).toLowerCase(),
    };

    // 移动端隐藏下载按钮
    if (browser.versions.mobile || browser.versions.ios || browser.versions.android
            || browser.versions.iPhone || browser.versions.iPad) {
      this.showDownloadBtn = false;
    }
    window.onresize = () => {
      this.ratio = document.body.clientWidth / 1280;
    };
    window.onscroll = () => {
      this.isScroll = window.pageYOffset > (522 * this.ratio);
    };
  },
  methods: {
    download() {
      downloadClick({
        name: 'cloud-detail-download-click',
        clientVersion: this.version,
      });
      window.open(this.downloadUrl, '_blank');
    },
  },
};
</script>
<style lang='less'>
.banner{
    background-image: url('../assets/img/banner.png');
    background-size: 100% 100%;
    .button{
      color:#fff;
      background:transparent;
      border:1px solid #fff;
      text-align:center;
      position:relative;
      cursor:pointer;
    }
}
.content-tab{
    font-family: "微软雅黑","Microsoft YaHei",sans-serif;
    background:rgb(154, 154, 218);
    color:#fff;
    ul{
        width:73.4%;
        height:100%;
        margin:0 auto;
        li{
            float:left;
            width:25%;
            list-style:none;
            text-align:center;
            cursor:pointer;
            a{
                color:#fff!important;
                text-decoration:none;
                display:inline-block;
                width:100%;
                height:100%;
            }
        }
        li:hover{
            background:#168CEF;
        }
    }
}
#content-1{
    background-image: url('../assets/img/content-1.png');
    background-size: 100% 100%;
}
#content-2{
    background-image: url('../assets/img/content-2.png');
    background-size: 100% 100%;
}
#content-3{
    background-image: url('../assets/img/content-3.png');
    background-size: 100% 100%;
    .more-detail{
        color:#157EDC!important;
        text-decoration:none;
        display:block;
        margin:0 auto;
        width:10%;
        text-align:center;
        position:relative;
        i{
            display:inline-block;
            background-size:100% 100%;
            background-image: url('../assets/img/arrow-right.png');
            vertical-align:baseline;
        }
    }
}
#content-4{
    background-image: url('../assets/img/content-4.png');
    background-size: 100% 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/cloud-download.vue